class Role {
    name = "";
    description = "";
}

export default Role;